
import useClientConfig from "../../common/hooks/clientConfigHook";
import CustomForm from "../../common/components/CustomForm";
import { Container } from "../../common/components/Grid";
import { useEpcrEditorEpcr, useEpcrEditorIntent } from "./EpcrContext";
import PropTypes from 'prop-types';
import { useMemo } from "react";
import { customCtrlTypeSupported } from "../../common/components/DataTable";
import { deepClone } from "../../common/utils/objectUtilities";

const EpcrInjuries = ({ disabled = false }) => {
    const clientConfig = useClientConfig();
    const { epcr, update } = useEpcrEditorEpcr();
    const intent = useEpcrEditorIntent();

    const def = useMemo(() => {
        if (intent === 'search' && clientConfig.epcrBodyForm) {
            let def = deepClone(clientConfig.epcrBodyForm);
            def.forEach(section => {
                section.rows = section.rows.map(row => row.filter(cell => customCtrlTypeSupported(cell)));
                section.rows = section.rows.filter(row => row.length > 0);
            });
            def = def.filter(section => section.rows.length > 0);
            return def;
        }
        return clientConfig.epcrBodyForm;
    }, [intent, clientConfig.epcrBodyForm]);

    const runUpdate = (value) => {
        update('injuries', value);
    }

    return <Container fluid>
        {clientConfig.enableInjuriesImage ?
                <div className="d-flex justify-content-center mt-3"><img  src="images/body_diagram.jpg" alt="body diagram" style={{objectFit: "contain", maxWidth: '500px', maxHeight:'500px'}}/></div> : null}
        <CustomForm disabled={disabled} hideLabel={true} def={def} data={epcr?.injuries ?? {}} onChange={runUpdate}></CustomForm>
    </Container>
}

EpcrInjuries.propTypes = {
    pcrid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disabled: PropTypes.bool
}

export default EpcrInjuries;